import React from 'react';
import api from 'api';
import MessagesListing from '../components/Listing';

class Listing extends React.Component {
  constructor(props) {
    super(props);
    this.api = this.props.api.message;
    this.handleClickCheckboxAll = this.handleClickCheckboxAll.bind(this);
    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.handleActionSuccessul = this.handleActionSuccessul.bind(this);
  }
  componentDidMount() {
    this._listingReady = false;
    this.refreshListing(this.props);
    this.api.setData({
      selectedItems: {},
      allCheckboxesChecked: false,
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this._listingReady = false;
      this.refreshListing(nextProps);
    }
  }
  componentWillUnmount() {
    this.api.leaveListing();
    this.api.setData({
      selectedItems: {},
      allCheckboxesChecked: false,
    });
  }
  render() {
    return (
      <MessagesListing
        { ...this.props }
        mountedUrl="/email/messages"
        messages={ this.props.objects.messages }
        listingReady={ this._listingReady }
        onRefresh={ this.refreshListing.bind(this, this.props) }
        onSelectFolder={ this.handleChangeListingParams.bind(this, 'folder') }
        onSelectFilter={ this.handleChangeListingParams.bind(this, 'filter') }
        onPageChange={ this.handleChangeListingParams.bind(this, 'page') }
        onSearch={ this.handleChangeListingParams.bind(this, 'search') }
        onDismissAlert={ this.api.dismissAlert }
        onClickCheckboxAll={ this.handleClickCheckboxAll }
        onSelectItem={ this.handleSelectItem }
        onActionSuccessful={ this.handleActionSuccessul }
      />
    );
  }

  refreshListing(props) {
    const query = props.location.query || {};
    const selectedFolder = query.folder || 'inbox';
    const search = query.search;
    const page = query.page;
    let selectedFilter = query.filter;
    if (selectedFolder !== 'inbox' && selectedFolder !== 'notifications') {
      selectedFilter = null;
    }
    this.api.getData({ url: '/get-data-for-listing' })
      .then(({ nbMessagesByFolder, folders, filters }) => {
        return this.api.setData({ nbMessagesByFolder, folders, filters });
      })
      .then(() => this.api.fetchMessages({ selectedFolder, selectedFilter, search, page }))
      .then(() => this._listingReady = true);
  }
  handleChangeListingParams(attributeName, value) {
    const page = attributeName !== 'page' ? 1 : value;
    const query = { ...this.props.location.query, [attributeName]: value, page };
    this.props.router.push({ ...this.props.location, query });
  }
  handleClickCheckboxAll() {
    const allCheckboxesChecked = !this.props.allCheckboxesChecked;
    const selectedItems = this.props.objects.messages.reduce((result, message) => {
      return { ...result, [message.id]: allCheckboxesChecked };
    }, {});
    this.api.setData({ allCheckboxesChecked, selectedItems });
  }
  handleSelectItem(id) {
    const checked = !this.props.selectedItems[id];
    const selectedItems = { ...this.props.selectedItems, [id]: checked };
    this.api.setData({ selectedItems });
  }
  handleActionSuccessul() {
    this.api.setData({
      selectedItems: {},
      allCheckboxesChecked: false,
    });
    this.refreshListing(this.props);
  }
}

Listing.propTypes = {
  api: React.PropTypes.object,
  router: React.PropTypes.object,
  deleteSuccessful: React.PropTypes.bool,
};

export default api.connect(Listing, 'message');



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/containers/Listing.jsx